import { useEffect, useState } from "react";
import { getUserTags, subscribeToUserTags } from "../api/tags";

export const useUserTags = (userUid) => {
  const [userTags, setUserTags] = useState([]);
  const [loading, setLoading] = useState(false)


  useEffect(() => {
    setLoading(true);
    subscribeToUserTags(userUid, (querySnapshot) => {
      const tags = querySnapshot.docs.map(doc => ({ ...doc.data() /** {name: string} */, id: doc.id }));
      setUserTags(tags)
      setLoading(false)
    })
  }, [userUid])


  return [userTags, loading]
  
}